import { connect } from "react-redux";
import { Dispatch } from "redux";
import { mp_addTab } from "../../../../redux/reducers/MembersPortalReducer";
import IAppState from "../../../../redux/types/IAppState";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import { MemberStatementDetailsPage } from "./MemberStatementDetailsPage";
import { useInternalMessage } from "antd/es/message/useMessage";

export default connect(
    (state: IAppState) => ({
        paymentDetailPageComponentData: state.membersPortal.componentData.MemberStatementDetailsPage,
        paymentDetailGridsComponentData: state.membersPortal.componentData.MemberStatementDetailsGridsView,
        paymentSummaryGridsComponentData: state.membersPortal.componentData.MemberStatementPaymentSummaryGridsView,
        payment: state.membersPortal.tabs[state.membersPortal.activeTab].memberStatementDetailsState && state.membersPortal.tabs[state.membersPortal.activeTab].memberStatementDetailsState.payment,
        userNameNumber: state.account.currentUserNameNumber,
        refreshKey: state.membersPortal.tabs[state.membersPortal.activeTab].memberStatementDetailsState && state.membersPortal.tabs[state.membersPortal.activeTab].memberStatementDetailsState.refreshKey,
    }),
    (dispatch: Dispatch) => ({
        addTab: (tab: ITabReduxItem) => dispatch(mp_addTab(tab)),
    })
)(MemberStatementDetailsPage);
